/* eslint-disable @angular-eslint/component-selector */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ClientReferralTask } from '../../../core/models/client-referral-task.model';
import { RouterLink } from '@angular/router';
import { UserPresenceComponent } from '../../../shared/components/user-presence/user-presence.component';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { TaskEstimatedValueComponent } from '../../../shared/components/task-estimated-value/task-estimated-value.component';
import { ExpirationDateComponent } from '../../../shared/components/expiration-date/expiration-date.component';
import { DecimalPipe, DatePipe } from '@angular/common';
import { TaskStatusPipe } from '../../../shared/pipes/task-status.pipe';
import { ClaimSourcePipe } from '../../../shared/pipes/claim-source.pipe';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: '[app-client-referral-task-list-row]',
    templateUrl: './client-referral-task-list-row.component.html',
    styleUrls: ['./client-referral-task-list-row.component.scss'],
    imports: [RouterLink,
              UserPresenceComponent,
              PrescriberNameComponent,
              TaskEstimatedValueComponent,
              ExpirationDateComponent,
              DecimalPipe,
              DatePipe,
              TaskStatusPipe,
              ClaimSourcePipe,
              BlankValueDashPipe]
})
export class ClientReferralTaskListRowComponent implements OnInit {
  @Input() task: ClientReferralTask;
  @Input() position: number;

  @Output() viewTask = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  onViewClick() {
    this.viewTask.emit(this.position);
  }
}
